import supabase from "../../../shared/database/supabase";
import { toInclusiveTimestampRange } from "../../../shared/lib/date-range";
import { Pericia } from "../model";

export interface ListPericiasNotBilledRequest {
  start: Date;
  end: Date;
  costumer_id: string;
}

export const ListPericiasNotBilled = async ({ start, end, costumer_id }: ListPericiasNotBilledRequest): Promise<Pericia[]> => {
  try {
    const range = toInclusiveTimestampRange({ start, end });
    const { data, error } = await supabase.functions.invoke("list-pericias-not-billed", {
      body: JSON.stringify({ start: range.start, end: range.end, costumer_id })
    });

    if (error) throw error;
    if (!data || data.length === 0) {
      return [];
    }

    return data.map((pericia: Pericia) => ({
      ...pericia,
      createdAt: new Date(pericia.createdAt),
      updatedAt: new Date(pericia.updatedAt),
      date: new Date(pericia.date)
    }));
  } catch (err) {
    console.log(err);
    throw err;
  }
};
